<template>
  <div class="activity-rule-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" :title="$t('lang.ActCommon.k009')" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="bg-block">
      <div class="item-block">
        <div class="item-tit">{{ $t('lang.ActCommon.k025') }}</div>
        <div class="item-txt">
          1. {{ $t('lang.ActCommon.k026') }}:
          <br />
          <i style="color: #ff6224" v-if="actStartTime && actEndTime">{{ actStartTime }} - {{ actEndTime }}</i>
        </div>
        <div class="item-txt">2. {{ $t('lang.ActCommon.k092') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.ActCommon.k027') }}</div>
        <div class="item-txt">1. {{ $t('lang.ActCommon.k067') }}</div>
        <!-- prettier-ignore -->
        <div class="item-tip-b">{{ $t('lang.ActCommon.k068') }} 1 {{ $t('lang.ActCommon.k096') }} <i>{{ $t('lang.ActCommon.k069') }}</i></div>
        <!-- prettier-ignore -->
        <div class="item-tip-b">{{ $t('lang.ActCommon.k070') }} 3 {{ $t('lang.ActCommon.k097') }} <i>{{ $t('lang.ActCommon.k069') }}</i></div>
        <div class="item-txt">2. {{ $t('lang.ActCommon.k083') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.EidAlFitr.k017') }}</div>
        <div class="item-txt">1. {{ $t('lang.EidAlFitr.k024') }}</div>
        <div class="item-txt">{{ $t('lang.EidAlFitr.k025') }}</div>
        <div class="item-txt">{{ $t('lang.EidAlFitr.k026') }}</div>
        <div class="item-txt">2. {{ $t('lang.EidAlFitr.k027') }}</div>
        <div class="item-txt">3. {{ $t('lang.EidAlFitr.k028') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.ActCommon.k017') }}</div>
        <div class="item-txt">1. {{ $t('lang.ActCommon.k076') }}</div>
        <div class="item-txt">
          2. {{ $t('lang.ActCommon.k077') }}
          <br />
          <i style="color: #ff9524" v-if="actEndTime">{{ actEndTime }}</i>
        </div>
        <div class="item-txt">3. {{ $t('lang.ActCommon.k078') }}</div>

        <div class="reward-item" style="margin-top: 16px">
          <div class="reward-num">No.1</div>
          <div class="reward-coins">
            {{ boardData.num1Reward }}
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
        <div class="reward-item">
          <div class="reward-num">No.2</div>
          <div class="reward-coins">
            {{ boardData.num2Reward }}
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
        <div class="reward-item">
          <div class="reward-num">No.3</div>
          <div class="reward-coins">
            {{ boardData.num3Reward }}
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
        <div class="reward-item">
          <div class="reward-num">No.4-10</div>
          <div class="reward-coins">
            {{ boardData.num4Reward }}
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.ActCommon.k091') }}</div>
        <div class="item-txt">1. {{ $t('lang.ActCommon.k079') }}</div>
        <div class="item-txt">2. {{ $t('lang.ActCommon.k093') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { normalActBaseInfo } from './apidir/api.js'

export default {
  data() {
    return {
      actStartTime: '',
      actEndTime: '',
      boardData: {
        num1Reward: 1200,
        num2Reward: 800,
        num3Reward: 500,
        num4Reward: 100
      }
    }
  },
  methods: {
    // 获取数据
    fetchData() {
      normalActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          if (resData.startTimestamp) {
            this.actStartTime = this.handleMoment(resData.startTimestamp, 'YYYY-MM-DD HH:mm:ss')
          }
          if (resData.endTimestamp) {
            this.actEndTime = this.handleMoment(resData.endTimestamp, 'YYYY-MM-DD HH:mm:ss')
          }
        }
      })
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    document.body.scrollTo({ top: 0 })
  }
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.activity-rule-root {
  width: 100%;
  min-height: calc(100vh - 150px);
  background: #135e38;

  .custom-nav-block {
    background: #135e38;
  }

  .bg-block {
    position: relative;
    min-height: 100vh;

    padding: 20px 10px;

    .item-block {
      width: 100%;
      padding: 16px;
      margin-bottom: 16px;
      border-radius: 12px;
      background: #f4faf2;

      .item-tit {
        line-height: 22px;
        font-family: 'TikTokSans-Regular';
        font-weight: bold;
        font-size: 17px;
        color: #064224;
        line-height: 22px;
      }

      .item-txt {
        width: 323px;
        line-height: 22px;
        font-family: 'TikTokSans-Regular';
        font-size: 15px;
        color: #064224;
        margin-top: 8px;
      }

      .item-tip-b {
        color: #064224;
        font-family: 'TikTokSans-Regular';
        font-size: 17px;
        font-weight: 700;
        margin-top: 8px;
        i {
          color: #064224;
          font-family: 'Roboto-Regular';
          font-size: 17px;
          font-weight: 400;
        }
      }

      .item-tip-r {
        color: #064224;
        font-family: 'TikTokSans-Regular';
        font-size: 15px;
        font-weight: 600;
        margin-top: 8px;
      }

      .gift-num {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
        > div {
          display: flex;
          align-items: center;
          gap: 10px;

          font-family: 'TikTokSans-Regular';
          font-weight: 400;
          font-size: 17px;
          color: #064224;
          line-height: 20px;

          img {
            width: 24px;
            height: 24px;
          }
        }
        > span {
          font-family: 'TikTokSans-Regular';
          font-weight: 400;
          font-size: 17px;
          color: #064224;
          line-height: 20px;
          text-align: right;
        }
      }

      .reward-item {
        font-family: 'TikTokSans-Regular';
        font-weight: 400;
        font-size: 15px;
        color: #064224;
        line-height: 20px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        .reward-coins {
          display: flex;
          align-items: center;
          font-weight: bold;
          .coins-icon {
            width: 16px;
            height: 16px;
            margin: 0 3px;
          }
        }
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: 'Inter-Regular';
  font-weight: 600;
  color: #ffffff;
}
::v-deep .van-nav-bar__right .tit-right {
  line-height: 16px !important;
}
</style>
